import type { UserProject } from '@teachur/http-client';
import { useCurrentUser } from '@hooks/users';
import { getProjectReviewPermissions } from '../utils/projectReviewDrawerHelpers';

export const useProjectReviewPermissions = (
  selectedProject: UserProject | null,
  isCourseCompleted = false
) => {
  const { data: currentUser } = useCurrentUser();
  const currentUserId = currentUser?.id;
  const isAdmin = currentUser?.role === 'admin';

  const permissions = getProjectReviewPermissions({
    selectedProject,
    currentUserId,
    isAdmin,
    isCourseCompleted,
  });

  return {
    currentUserId,
    isAdmin,
    ...permissions,
  };
};
